import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "@/components/ScrollToTop";
import SitePopup from "@/components/SitePopup";
import DocumentHead from "@/components/DocumentHead";
import { AuthProvider } from "@/context/AuthContext";
import { MonturesProvider } from "@/context/MonturesContext";
import Home from "@/pages/Home";
import Montures from "@/pages/Montures";
import Services from "@/pages/Services";
import Contact from "@/pages/Contact";
import MentionsLegales from "@/pages/MentionsLegales";
import PolitiqueConfidentialite from "@/pages/PolitiqueConfidentialite";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ProtectedAdminRoute from "@/components/admin/ProtectedAdminRoute";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <MonturesProvider>
                        <ScrollToTop />
                        <DocumentHead />
                        <SitePopup />
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/montures" element={<Montures />} />
                            <Route path="/services" element={<Services />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route
                                path="/mentions-legales"
                                element={<MentionsLegales />}
                            />
                            <Route
                                path="/politique-de-confidentialite"
                                element={<PolitiqueConfidentialite />}
                            />
                            <Route path="/admin/login" element={<AdminLogin />} />
                            <Route
                                path="/admin"
                                element={
                                    <ProtectedAdminRoute>
                                        <AdminDashboard />
                                    </ProtectedAdminRoute>
                                }
                            />
                        </Routes>
                    </MonturesProvider>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
